import { useState, useEffect } from 'react';

// Hook
function useWindowSize(elemId) {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      let width = window.innerWidth;
      let height = window.innerHeight;
      if (elemId) {
        const elem = document.getElementById(elemId);
        if (elem) {
          width = elem.scrollWidth;
          height = elem.scrollHeight;
        }
      }
      setWindowSize({
        width,
        height,
      });
    }

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

export default useWindowSize;
